
import { headers, formateData } from "./index";
import {applicationName} from "../utils";
export const headerJson = {
    Pragma: "no-cache",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json;charset=UTF-8",
};

//图集列表
export const getClueManageList = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/newsclue/getByStatus";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};
export const getClueadoptData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/newsclue/useclue";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};
export const getClueabandonData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/newsclue/unuseclue";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};
// 获取线索id
export const getClueId = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/newsclue/getById";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};
// 获取图片
export const getPicture = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/newsclue/getPicture";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};
// 获取视频
export const getVideo = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/newsclue/getVideo";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};
// 获取附件
export const getAttachment = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/newsclue/getAttachmentFile";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAtlasList", error);
            callBack("");
        });
};